export async function hykeCamTimeout(vm) {
  let payload = {
    cameraId: vm.camera.id,
  };
  let res = await vm.hykeCamGetMedia(payload);
  if (vm.hykeCamUrl != res.url) {
    vm.hykeCamUrl = res.url;
    if (vm.$refs.hykeCamVideo) {
      vm.$refs.hykeCamVideo.src = vm.hykeCamUrl;
    }
  }
}

export async function hykeCamResize(vm) {
  if (vm.$refs.hykeCamVideo) {
    vm.hykeCamHeight = vm.$refs.hykeCamVideo.clientHeight;
  }
}

export async function hykeCamLoadStart(vm) {
  if (vm.$refs.hykeCamCameraArea) {
    vm.hykeCamLoaderHeight = vm.$refs.hykeCamCameraArea.clientHeight / 4;
    vm.hykeCamLoaderWidth = vm.hykeCamLoaderHeight;
    vm.hykeCamLoaderTop =
      vm.$refs.hykeCamCameraArea.clientHeight / 2 - vm.hykeCamLoaderHeight / 2;
    vm.hykeCamLoaderLeft =
      vm.$refs.hykeCamCameraArea.clientWidth / 2 - vm.hykeCamLoaderWidth / 2;
    vm.hykeCamLoaderShow = true;
  }
}

export async function hykeCamLoadedData(vm) {
  vm.hykeCamLoaderShow = false;
  if (vm.$refs.hykeCamVideo) {
    vm.hykeCamHeight = vm.$refs.hykeCamVideo.clientHeight;
  }
}

export async function hykeCamScreen(vm) {
  const video = vm.$refs.hykeCamVideo;
  if (!video) return;
  if (video.requestFullScreen) {
    video.requestFullScreen();
  } else if (video.webkitRequestFullScreen) {
    video.webkitRequestFullScreen();
  } else if (video.webkitEnterFullscreen) {
    video.webkitEnterFullscreen();
  } else if (video.mozRequestFullScreen) {
    video.mozRequestFullScreen();
  } else if (video.msRequestFullscreen) {
    video.msRequestFullscreen();
  }
}
